import { defaultStoreUtils } from '@databases/redux';
import { type JiraIssueRef } from '@databases/types/confluence';
import { selectJiraIssueOptional } from '@databases/utils/redux/jira/selectors';
import React, { type FunctionComponent } from 'react';
import styled from 'styled-components';

const Img = styled.img`
  width: 14px;
  height: 14px;
`;

const JiraIssueIcon: FunctionComponent<{ issue: JiraIssueRef }> = ({ issue }) => {
  const [resolvedIssue] = defaultStoreUtils.useShallowEqualSelector((state) => {
    return [selectJiraIssueOptional(state, issue)] as const;
  });

  return resolvedIssue?.typeIconUrl ? (
    <Img src={resolvedIssue.typeIconUrl} alt="" />
  ) : null;
};

export default JiraIssueIcon;
